module.exports = __webpack_public_path__ + "img/title-2.226ca6af.png";